
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17 0L0 9.131V28.87L17 38l17-9.13V9.13L17 0zm4.626 20.448v-3.859l6.964-2.943.366.874-6.387 2.698v4.041l-5.118 3.207v2.228l2.35 1.383 2.652-1.403.44.838-3.115 1.649-2.794-1.644-2.793 1.644-3.115-1.649.439-.838 2.652 1.403 2.341-1.377v-2.241l-5.109-3.2v-4.04l-6.387-2.7.366-.873 6.964 2.943v3.859h9.284z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.573 21.395h-7.146L17 23.642l3.573-2.247z","fill":"#fff"}})])
          )
        }
      }
    